import { motion, type HTMLMotionProps } from 'framer-motion';
import type { ReactNode } from 'react';
import { transitionSmooth } from '../../lib/motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface RevealProps extends Omit<HTMLMotionProps<'div'>, 'children'> {
  children: ReactNode;
  delay?: number;
  y?: number;
  as?: 'div' | 'section' | 'article' | 'header' | 'footer' | 'span';
}

export function Reveal({
  children,
  delay = 0,
  y = 24,
  as = 'div',
  ...props
}: RevealProps) {
  const reducedMotion = useReducedMotion();
  const MotionTag = motion[as] as typeof motion.div;
  return (
    <MotionTag
      initial={reducedMotion ? false : { opacity: 0, y }}
      whileInView={reducedMotion ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ ...transitionSmooth, delay }}
      {...props}
    >
      {children}
    </MotionTag>
  );
}
